/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StartDate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function StartDate({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/EditLength/Content/StartDate",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let editLengthStartDateValueData = fromData.useDataFormat({ viewPath,
context: 'edit_length',
path: 'start_date',
format: fromFormat.dateISOIn,
})
let editLengthStartDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_length',
path: 'start_date',
validate: fromValidate.date,
required: true,
})
let editLengthStartDateChangeData = fromData.useDataChange({ viewPath,
context: 'edit_length',
path: 'start_date',
formatOut: fromFormat.dateShortOut,
})
let editLengthStartDateSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_length',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_length.start_date"
 format="/Data/format.js dateISOIn"
 formatOut="/Data/format.js dateShortOut"
 validate="/Data/validate.js date"
 invalid={!editLengthStartDateIsValidData}
 required={true}
 value={editLengthStartDateValueData}
 onChange={editLengthStartDateChangeData}
 onSubmit={editLengthStartDateSubmitData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Start date"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 autoFocus={true}
 mask="date"
 placeholder="mm/dd/yyyy"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}